import { atomWithStorage } from 'jotai/utils';

export const ORDERS_YEAR_STORAGE_KEY = 'precifield.orders-year';
export const ordersYearAtom = atomWithStorage<number | undefined>(
  ORDERS_YEAR_STORAGE_KEY,
  new Date().getFullYear(),
);

export const getOrdersYear = () => {
  const year = localStorage.getItem(ORDERS_YEAR_STORAGE_KEY);

  try {
    return JSON.parse(year as string);
  } catch {
    return year;
  }
};

export default getOrdersYear;
